// @flow
import './RefinementMenu.css';
import React, { Component } from 'react';
// Components
import {
  RefinementList,
  ClearRefinements,
  ToggleRefinement,
  Panel,
} from 'react-instantsearch-dom';
import MiniColorRow from '../../header/components/MiniColorRow';
import ConditionalPricePanel from './ConditionalPricePanel';

type Props = {
  showSalesRefinement: boolean,
};

class RefinementMenu extends Component {
  props: Props;

  render() {
    const { showSalesRefinement } = this.props;

    return (
      <div>
        <div className="search-page-menu">
          <ConditionalPricePanel attribute="normalized_price" />
          {showSalesRefinement && (
            <ToggleRefinement
              attribute="on_sale"
              label="Promoção"
              value={true}
            />
          )}
          <Panel>
            <MiniColorRow color="white" text="FABRICANTE" />
            <RefinementList attribute="manufacturer" />
          </Panel>
          <Panel>
            {/* TODO: Add these after fixing issue with '.' in name */}
            <MiniColorRow color="white" text="MODO DE PREPARO" />
            <RefinementList attribute="cooking_recommendations.name" />
          </Panel>
          {/* <Panel>
                <MiniColorRow color="white" text="TIPO DE CORTE" />
                <RefinementList attributeName="option_values.presentation" />
              </Panel> */}
          <div className="search-page-hits-clear">
            <ClearRefinements
              translations={{
                reset: 'Resetar filtros',
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default RefinementMenu;
